import { render, staticRenderFns } from "./SelectedUser.vue?vue&type=template&id=55e8191d"
import script from "./SelectedUser.vue?vue&type=script&lang=js"
export * from "./SelectedUser.vue?vue&type=script&lang=js"
import style0 from "./SelectedUser.vue?vue&type=style&index=0&id=55e8191d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports